import React from 'react'
import { StyledButton, Props } from './styled'

export const Button: React.FC<Props> = (props: Props) => {
  return <StyledButton {...props}>{props.children}</StyledButton>
}
